import React from "react";

const WarningIconSharp = ({ className = "", size = "24", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 55 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Main warning triangle shape - same as original but without glow effects */}
      <path
        d="M6.91608 19.5275C11.0457 12.2734 13.1105 8.64634 15.8062 7.4291C18.1575 6.36738 20.8425 6.36738 23.1938 7.4291C25.8895 8.64634 27.9543 12.2734 32.0839 19.5275C36.2135 26.7817 38.2783 30.4088 37.9698 33.3851C37.7008 35.9811 36.3583 38.3394 34.276 39.8738C31.8888 41.6328 27.7592 41.6328 19.5 41.6328C11.2408 41.6328 7.11125 41.6328 4.72399 39.8738C2.64173 38.3394 1.29919 35.9811 1.03015 33.3851C0.721706 30.4088 2.7865 26.7817 6.91608 19.5275ZM19.4999 34.2644C20.503 34.2644 21.3162 33.4397 21.3162 32.4223C21.3162 31.4049 20.503 30.5802 19.4999 30.5802C18.4968 30.5802 17.6836 31.4049 17.6836 32.4223C17.6836 33.4397 18.4968 34.2644 19.4999 34.2644Z"
        fill="#F59E0B"
        stroke="#D97706"
        strokeWidth="1"
        strokeLinecap="round"
      />
      
      {/* Exclamation mark - same as original */}
      <path
        d="M18.7982 28.3112C17.7667 28.3112 16.9251 27.4855 16.9055 26.4543L16.7201 16.7318C16.6979 15.5687 17.6348 14.6138 18.7982 14.6138C19.9616 14.6138 20.8984 15.5687 20.8762 16.7318L20.6909 26.4543C20.6712 27.4855 19.8296 28.3112 18.7982 28.3112ZM18.7982 35.3631C18.1597 35.3631 17.6083 35.1406 17.144 34.6956C16.699 34.2313 16.4766 33.6799 16.4766 33.0415C16.4766 32.403 16.699 31.8613 17.144 31.4163C17.6083 30.952 18.1597 30.7199 18.7982 30.7199C19.4366 30.7199 19.9783 30.952 20.4233 31.4163C20.8876 31.8613 21.1198 32.403 21.1198 33.0415C21.1198 33.6799 20.8876 34.2313 20.4233 34.6956C19.9783 35.1406 19.4366 35.3631 18.7982 35.3631Z"
        fill="white"
      />
    </svg>
  );
};

export default WarningIconSharp;
